import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BoatCard } from "@/components/public/BoatCard";
import { LeadDialog } from "@/components/public/LeadDialog";
import { Seo } from "@/components/Seo";
import { api } from "@/lib/api";

export default function SeoPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [boats, setBoats] = useState([]);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null); setNotFound(false);
    api.get(`/seo-pages/${slug}`).then((r) => {
      setPage(r.data);
      const f = r.data.filter || {};
      const qp = new URLSearchParams(f).toString();
      api.get(`/boats?${qp}`).then((b) => setBoats((b.data || []).filter((x) => x.status !== "sold").slice(0, 9))).catch(() => {});
    }).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="max-w-3xl mx-auto px-4 py-24 text-center"><h1 className="text-3xl font-bold font-heading">Page not found</h1><Button asChild className="mt-6 bg-mtm-purple text-white rounded-full"><Link to="/">Home</Link></Button></div>;
  if (!page) return <div className="max-w-7xl mx-auto px-4 py-24 text-center text-slate-500">Loading...</div>;

  return (
    <div data-testid={`seo-page-${slug}`}>
      <Seo title={page.meta_title} description={page.meta_description} />
      <section className="bg-mtm-charcoal text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <p className="text-xs font-bold uppercase tracking-widest text-mtm-teal-bright font-mono">Bristol, Tennessee</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold font-heading tracking-tight mt-2 max-w-3xl">{page.h1}</h1>
          <p className="text-lg text-slate-200 mt-4 max-w-2xl">{page.intro}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-14">
        {boats.length ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">{boats.map((b, i) => <BoatCard key={b.id} boat={b} index={i} />)}</div>
        ) : (
          <p className="text-slate-500">No matching boats in stock right now. <LeadDialog ctaType="Inventory Inquiry" triggerLabel="Ask about availability" variant="outline" className="ml-2" /></p>
        )}
        <div className="mt-10 flex flex-wrap gap-3 text-sm">
          <Link to="/inventory" className="text-mtm-purple font-semibold hover:underline flex items-center gap-1">All Inventory <ArrowRight size={14} /></Link>
          <Link to="/brands/falcon" className="text-mtm-purple font-semibold hover:underline">Falcon</Link>
          <Link to="/brands/armada" className="text-mtm-purple font-semibold hover:underline">Armada</Link>
          <Link to="/service" className="text-mtm-purple font-semibold hover:underline">Service</Link>
          <Link to="/contact" className="text-mtm-purple font-semibold hover:underline">Contact</Link>
        </div>
      </section>
    </div>
  );
}
